import { SvgIcon } from '@mui/material';
import { Package2Icon } from 'components/Icons';

import {
  Equalizer as EqualizerIcon,
  Home as HomeIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

export const items = [
  {
    title: 'Products',
    path: '/products',
    icon: (
      <SvgIcon fontSize="small">
        <Package2Icon />
      </SvgIcon>
    )
  },
  {
    title: 'Budgets',
    path: '/budgets',
    icon: (
      <SvgIcon fontSize="small">
        <EqualizerIcon />
      </SvgIcon>
    )
  },
  "-"
  ,
];